import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  navigationPage: null,
  errorMeApi: null,
  error: null,
  services: [],
  allDataFetched: false
}

const slice = createSlice({
  name: 'landing',
  initialState: initialState,
  reducers: {
    landingAction: (state) => {
      state.loading = true
      state.error = null
    },
    landingSuccessAction:(state, action)=>{
      state.loading = true
      state.navigationPage = action.payload
      state.error = null
    },
    landingErrorAction: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.navigationPage = null
    },
    getLandingContentAction: (state) => {
      state.loading = false
      state.error = null
      state.navigationPage = null
    },
    setLandingContentAction:(state, action)=>{
      state.loading = false
      state.services = action.payload
      state.error = null
    },
    setLandingAllDataFetchedAction:(state, action)=>{
      state.loading = false
      state.allDataFetched = action.payload
      state.error = null
    },
    landingMeErrorAction: (state, action) => {
      state.loading = false
      state.navigationPage = null
      state.errorMeApi = action.payload
    },
    landingResetState: () => initialState,
  },
});

export const {
  landingAction,
  landingSuccessAction,
  landingErrorAction,
  landingResetState,
  landingMeErrorAction,
  getLandingContentAction,
  setLandingContentAction,
  setLandingAllDataFetchedAction
} = slice.actions

export default slice.reducer
